import inputs from "../../../../inputs/inputConfigs/submittals";

export default (disableSelectFile, timezone) => ({
  groups: [
    {
      items: [
        {
          input: {
            ...inputs.submittalFile,
            disabled: disableSelectFile,
            ignoreLabeledText: true,
            inputFileProps: { disabled: disableSelectFile, isForm: true },
          },
          grid: { xs: 12 },
        },
        {
          input: {
            ...inputs.submittalCreatedAt,
            timezone,
            ignoreLabeledText: true,
          },
          grid: { xs: 6 },
        },
        {
          grid: { xs: 6 },
        },
      ],
    },
  ],
});
